
// src/web/components/right-side-page.jsx

import React from 'react'
import connect from '../../connects/right-side-page'
import {
  Navigation,
} from 'react-toolbox/lib/navigation'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import AppBar from 'react-toolbox/lib/app_bar'
import Avatar from 'react-toolbox/lib/avatar'
import rightSidePageAppBarTheme from './themes/right-side-page-app-bar.css'
import appBarTheme from 'react-toolbox/lib/app_bar/theme.css'
import _ from 'lodash'
import ReactDOM from 'react-dom'

class RightSidePage extends React.Component {
  scrollTo = (offset) => {
    offset ? ReactDOM.findDOMNode(this.refs.scrollBase).scrollTop += offset : ReactDOM.findDOMNode(this.refs.scrollBase).scrollTop = 0
  }
  kpiScrollPosition = () => {
    return ReactDOM.findDOMNode(this.refs.scrollBase).scrollTop
  }

  constructor(props) {
    super()
    if (props.innerRef)
      props.innerRef(this)
  }

  renderGroupMemberIcon = () => {
    const { members } = this.props
    const renderItem = members && <Avatar key={members[0].user_id} image={members[0].icon_image.thumb_url} theme={rightSidePageAppBarTheme} />
    return renderItem
  }

  render() {
    const {
      t,
      title,
      subTitle,
      image,
      icon,
      icon_image,
      members,
      children,
      closeRightSidePage,
      rightAction,
      key,
      absoluteFooter,
      childrenNotScroll,
      profile,
    } = this.props

    return (
      <div className={rightSidePageAppBarTheme.baseDiv} key={key}>
        <AppBar
          flat
          theme={rightSidePageAppBarTheme}
          leftIcon={
            icon_image ?
              <Avatar icon={icon} image={icon_image.thumb_url} />
              :
              !members && <Avatar icon={icon} image={image} /> || this.renderGroupMemberIcon()
          }
        >
          <div className={rightSidePageAppBarTheme.titleDiv}>
            {!subTitle && <h1 className={appBarTheme.title}>{_.unescape(title)}</h1>}
            {subTitle &&
              <div className={rightSidePageAppBarTheme.subTitleDiv}>
                <h1 className={appBarTheme.title} style={{ marginBottom: 0 }}>{title}</h1>
                <span className={rightSidePageAppBarTheme.subTitle}>{subTitle}</span>
              </div>
            }
          </div>
          <Navigation type='horizontal' style={{ whiteSpace: 'nowrap' }} theme={rightSidePageAppBarTheme}>
            {rightAction}
            <IconButton icon='close' onClick={()=> closeRightSidePage(this.props)} />
          </Navigation>
        </AppBar>
        <div className={rightSidePageAppBarTheme.childrenDiv}>
          <div className={rightSidePageAppBarTheme.childrenScroll} ref='scrollBase'>
            {children}
          </div>
        </div>
        {absoluteFooter && <div className={rightSidePageAppBarTheme.absoluteFooter}>{absoluteFooter}</div> }
      </div>
    )
  }
}

export const RawRightSidePage = RightSidePage
export default connect(RightSidePage)



// WEBPACK FOOTER //
// ./src/web/components/right-side-page.jsx